import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

type ClickableLabelCheckboxProps = {
    checked: boolean;
    onChange: (checked: boolean) => void;
    id: string;
    label: string | undefined;
    onLabelClick: () => void;
    readOnly: boolean;
    labelClassName?: string;
    containerClassName?: string;
    tooltip?: string;
};

function ClickableLabelCheckbox(props: ClickableLabelCheckboxProps) {
    const element = (
        <div className={`text-nowrap form-group ${props.containerClassName}`}>
            <input
                id={props.id}
                type="checkbox"
                className={`form-check-input me-1 ${props.readOnly ? "read-only-check" : ""}`}
                checked={props.checked}
                onChange={(e) => (!props.readOnly ? props.onChange(e.target.checked) : false)}
                readOnly={props.readOnly}
            />
            <button type="button" className={`btn btn-link p-0 ${props.labelClassName}`} onClick={props.onLabelClick}>
                {props.label}
            </button>
        </div>
    );

    if (props.tooltip) {
        return <OverlayTrigger overlay={<Tooltip>{props.tooltip}</Tooltip>} delay={100}>{element}</OverlayTrigger>;
    }

    return element;
}

export default ClickableLabelCheckbox;
